<template>
    <div class="mh-card-subheader" @click="action" :class="{'clickable': clickable}">
        <b-row>
            <b-col class="title pt-1">
                <i class="far fa-fw" :class="icon" v-if="icon"></i>
                {{title}}
            </b-col>
            <b-col class="text-right">
                <span class="date">{{date}}</span>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    export default {
        name: 'SupportTicketMessageSection',
        props: {
            title:  String,
            date: String,
            icon: String,
            badge: String,
            clickable: Boolean
        },
        methods: {
            action: function() {
                if (this.clickable) this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    $color: #708190;

    .mh-card-subheader {
        background-color: $color !important;
        padding: 7px 20px !important;
        border-bottom: 1px solid $color !important;

        cursor: auto !important;

        .title {
            font-family: 'Montserrat', sans-serif;
            color: white;
            font-size: 0.75rem;
            font-weight: bold;
            letter-spacing: 0.5px;
            text-transform: uppercase;
        }

        .date {
            font-weight: normal;
            color: white;
            font-size: 0.75rem;
        }

        i {
            font-size: 0.8rem;
            margin-right: $list-icon-margin-right;
        }

        &:hover {
            background-color: $color !important;
        }

        &.clickable {
            cursor: pointer;
        }
    }
</style>
